// precisa vir antes de tudo: estados globais leem o localStorage ao importar
import './utils/helpers/safeStorage';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { i18n } from './i18n';
import * as Sentry from '@sentry/vue';

const app = createApp(App);

Sentry.init({
    app,
    dsn: 'https://a1a823190a41b2435def4f6d53c248df@o4504584095334400.ingest.us.sentry.io/4508964701339648',
    sendDefaultPii: true,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0,
});

// Session Replay é pesado (~60KB gzip): carrega fora do caminho crítico,
// depois que a página já está interativa.
window.addEventListener('load', () => {
    Sentry.lazyLoadIntegration('replayIntegration')
        .then((replayIntegration) => {
            Sentry.addIntegration(replayIntegration());
        })
        .catch(() => {
            // replay é opcional; falha de carregamento não deve afetar o checkout
        });
});

app.use(i18n).use(router).mount('#app');
